/** Maps life units to five heart slots. Free max = 10 (2 units/heart); VIP max = 20 (4 units/heart) — same 5 icons, ×2 in UI. */
export type HeartSlotState = 'empty' | 'half' | 'full';

/** Same as server free-tier cap (legacy default). */
export const MAX_LIFE_UNITS = 10;

/**
 * @param units Current life units (0 … maxUnits).
 * @param maxUnits Tier cap (10 free, 20 VIP).
 */
export function unitsToHeartSlots(units: number, maxUnits: number = MAX_LIFE_UNITS): HeartSlotState[] {
  const cap = Math.max(1, Math.floor(maxUnits));
  const u = Math.max(0, Math.min(cap, Math.floor(units)));
  const unitsPerHeart = cap / 5;
  const slots: HeartSlotState[] = [];

  for (let i = 0; i < 5; i++) {
    const chunk = Math.min(unitsPerHeart, Math.max(0, u - i * unitsPerHeart));
    if (chunk >= unitsPerHeart) {
      slots.push('full');
    } else if (chunk >= unitsPerHeart / 2) {
      slots.push('half');
    } else if (chunk > 0) {
      slots.push('half');
    } else {
      slots.push('empty');
    }
  }

  return slots;
}
